/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Button,
} from 'reactstrap';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import toastr from 'toastr';
import { Link } from 'react-router-dom';

import Loading from '../components/Loading';
import Content from '../components/layout/Content';
import FormError from '../components/formControls/FormError';
import SnipperButton from '../components/buttons/SpinnerButton';
import { getTagGroup, updateTagGroup } from '../api/tagGroup';
import { getTags } from '../api/tag';
import { getProduct } from '../api/product';

class TagGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      tagGroup: '',
      tags: [],
      product: '',
    };
  }

  async componentDidMount() {
    const { match: { params: { tagGroupId } } } = this.props;
    const { user } = this.props;
    // const masterUser = user.isAdmin ? user.id : user.masterUser;
    const masterUser = user && (user.masterUserId || user.id);
    const tagGroup = await getTagGroup({ id: tagGroupId });
    const ourTagGroup = tagGroup.data.tagGroup;
    const { Tags, TagGroupMaps } = ourTagGroup;
    // const product = await getProduct(tagGroup.data.tagGroup.productId);
    // console.log('product', product);

    this.setState({
      tagGroup: ourTagGroup,
      tagGroupMaps: TagGroupMaps,
      tags: Tags,
      // product: product.data.product,
    });
  }

  render() {
    const { intl } = this.props;
    const {
      loading, tagGroup, tags, product,
    } = this.state;

    const tagGroupDetailText = intl.formatMessage({ id: 'taggroup.detail' });
    const tagGroupNameText = intl.formatMessage({ id: 'taggroup.name' });
    const tagsText = intl.formatMessage({ id: 'tags' });
    const savedText = intl.formatMessage({ id: 'saved' });
    const saveText = intl.formatMessage({ id: 'save' });

    return (
      <Row>
        <Col>
          <Formik
            initialValues={
              {
                displayName: tagGroup && tagGroup.displayName,
              }
            }
            enableReinitialize
            onSubmit={async (submit) => {
              await updateTagGroup({ ...submit, id: tagGroup.id });
              toastr.success('', savedText);
            }}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              /* and other goodies */
            }) => (
              <Content
                  title={tagGroupDetailText}
                  breads={product && [
                    { to: `/panel/product/${product.id}`, name: product.displayName },
                    { name: tagGroupDetailText },
                  ]}
                >
                  {
                    tagGroup === '' ? <Loading />
                      : (
                        <form onSubmit={handleSubmit} encType="multipart/form-data">
                          <FormGroup>
                            <Label for="displayName">{tagGroupNameText}</Label>
                            <Input
                              type="text"
                              name="displayName"
                              id="displayName"
                              placeholder={tagGroupNameText}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.displayName}
                            />
                            {errors.name && <FormError error={errors.name} />}
                          </FormGroup>
                          <FormGroup>
                            <Label>{tagsText}</Label>
                            <div>
                              {
                                tags.map((tag) => (
                                  <Link key={tag.id} to={`/panel/tag/${tag.id}`}>
                                    <TagGroupButton
                                      type="button"
                                      outline
                                      color="info"
                                    >
                                      {tag.displayName}

                                    </TagGroupButton>
                                  </Link>
                                ))
                              }
                            </div>
                          </FormGroup>
                          <SnipperButton type="submit" loading={loading} text={saveText} />
                        </form>
                      )
                  }
                </Content>
            )}
          </Formik>
        </Col>
      </Row>
    );
  }
}

const TagGroupButton = styled(Button)`
  margin-right: 10px;
`;

const mapStateToProps = (state) => ({ user: state.auth.user, location: state.router.location });

export default injectIntl(connect(mapStateToProps)(TagGroup));
